import { lazy, Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '#components/Button'
import { Icon } from '#components/Icon'
import { Spinner } from '#components/Spinner'
import type { ErrorDescription } from '#features/ErrorHandling/errorHelpers'
import ReportIcon from '#icons/report-filled.svg'

const LazyReportErrorDialog = lazy(async () => {
  const { ReportErrorDialog } = await import('#features/ErrorHandling/ReportErrorDialog.tsx')
  return { default: ReportErrorDialog }
})

export const ErrorReportButton = ({ errorInfo }: { errorInfo: ErrorDescription[] }) => {
  const { t } = useTranslation('shared')
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false)

  return (
    <Suspense
      fallback={
        <Button className="button" disabled>
          <Spinner size="s" />
          {t('error-handler.button.report', 'Report')}
        </Button>
      }
    >
      <Button className="button" onClick={() => setIsReportDialogOpen(true)}>
        <Icon iconUrl={ReportIcon} size="s" />
        {t('error-handler.button.report', 'Report')}
      </Button>

      {isReportDialogOpen && <LazyReportErrorDialog errorInfo={errorInfo} onOpenChange={setIsReportDialogOpen} isOpen={isReportDialogOpen} />}
    </Suspense>
  )
}
